<template>
  <div>
    <StockPurchaseOrderListByStatus :statusId="statusId" :pageTitle="pageTitle">
    </StockPurchaseOrderListByStatus>
  </div>
</template>
<script>
//General
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

import { permissionMixin } from "@/core/mixins/permissionMixin.js";

import StockPurchaseOrderListByStatus from "@/modules/stock/components/purchase-orders/StockPurchaseOrderListByStatus.vue";

import _ from "lodash";
export default {
  name: "StockPurchaseOrderListNew",
  mixins: [permissionMixin],
  data() {
    return {
      statusId: 1,
      pageTitle: this.$t("LIST_NEW_STOCK_PURCHASE_ORDERS")
    };
  },
  components: { StockPurchaseOrderListByStatus },
  watch: {},
  mounted() {
    let vm = this;
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "New Stock Purchase Orders List" }
    ]);
  },
  computed: {},
  methods: {}
};
</script>
